import { render, staticRenderFns } from "./ServiceHistoryDocuments.vue?vue&type=template&id=cb5d0e86&scoped=true"
import script from "./ServiceHistoryDocuments.vue?vue&type=script&lang=js"
export * from "./ServiceHistoryDocuments.vue?vue&type=script&lang=js"
import style0 from "./ServiceHistoryDocuments.vue?vue&type=style&index=0&id=cb5d0e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5d0e86",
  null
  
)

export default component.exports